module.exports = __webpack_public_path__ + "static/media/206-header5.8f5a9df6.jpg";